import { carBrandcodes } from '../../constants';

export const footerDisclaimer = ({ fsgUrl, comparisonUrl }) => {
    return `<p>We recommend you read the Product Disclosure Statement (PDS) before you make a decision.</p>
            <p>Please note that when we display quotes on our comparison results page,
            they are indicative and subject to change based on further questions by the insurer.</p>`
        + `<p data-id="expandable">We do not compare all car insurers or products in the market.
            Any advice given above is general and does not take into account your objectives, financial situation or needs.
            You should consider whether the advice is suitable for you and your personal circumstances,
            and before you make any decision about whether to purchase a product, you should read the PDS for that product.
            A number of the car insurance brands on our panel are arranged by Auto & General Services Pty Ltd ACN 003 617 909
            on behalf of the insurer Auto & General Insurance Company Limited ACN 111 586 353, both of which are related entities of Compare the Market Pty Ltd.
            Our relationship with those companies does not impact the integrity of our comparison service,
            and we continue to work hard to encourage brands that do not currently participate on our comparison service to come on board.</p>`
        + `<p>For more information about the range of insurers and products we compare, how our service works,
            and how we make our money (remembering that the service is free for you to use),
            read our <a href="${comparisonUrl}" target="_blank">how our comparison works</a> page, and read our
            <a href="${fsgUrl}"
            target="_blank">Financial Services Guide (General Insurance Products)</a>.</p>`
        + '<p>The Compare The Market website and trading name are owned by Compare The Market Pty Ltd ACN 117 323 378 AFSL 422926.</p>';
};

export const trustedPartnerContent = () => {
    const trustedPartnerConfig = {
        title: 'Trusted Partners',
        description: 'Our Trusted Partners, for the purpose of your invitation to call, are:',
        reasons: [
            'the insurer that ranks in position 1 on the results page;',
            'any other insurer with whom you express an interest to contact, by commencing an online application or enquiry.'
        ],
        disclaimer: ''
    };
    return trustedPartnerConfig;
};

export const redbookDisclosureContent = () => {
    const redbookDisclosureConfig = {
        title: 'Vehicle Information Provided by Red Book',
        description: 'Vehicle information has been provided by Automotive Data Services Pty Ltd (Red Book). Red Book has prepared this '
            + 'data and valuations from information gathered from a variety of sources. Whilst all care has been taken in producing the '
            + 'data and valuations, Red Book cannot guarantee or make any representations regarding the use of, or reliance, on it. '
            + 'Red Book is not responsible for all the information provided to it and you should not rely on the data or valuations '
            + 'without making your own independent assessment for the vehicle and other sources of information. Red Book is not liable '
            + 'for any loss or damages (other than in respect of any liability which may not lawfully be excluded) relating to your use of, '
            + 'reliance on, this valuation and data.'
    };
    return redbookDisclosureConfig;
};

export const partnerBrands = () => [
    carBrandcodes.BUDD,
    carBrandcodes.EXOA,
    carBrandcodes.HUDD,
    carBrandcodes.OZIC,
    carBrandcodes.VIRG,
    carBrandcodes.WOOL,
    carBrandcodes.STEL,
    carBrandcodes.BUPA,
    carBrandcodes.AHM,
    carBrandcodes.EXCL
    // uncomment below line to turn on Carpeesh
    // carBrandcodes.CARP
];

export const crossSellOtherVerticalsOnResults = () => true;
export const showNoResultsOverlayGenericMessage = () => false;
export const resultsScreenDefaultDisplayMode = () => 'row';

export const contactDetailOptInPrivacyMessage = ({ companyName, fsgUrl, privacyPolicyUrl, toyPromo }) => {
    return `I have read and accept ${companyName}'s${toyPromo ? ` ${toyPromo}, ` : ''}
    <a href='${privacyPolicyUrl}' target="_blank" data-id="websitePrivacyPolicyFormTermsLink" rel="noopener noreferrer">Privacy Collection Notice</a>
      and <a href='${fsgUrl}' target="_blank" data-id="websiteFinancialServicesGuideLink" rel="noopener noreferrer">Financial Services Guide</a>,
      including that ${companyName} may email and SMS me about the services it provides. By providing a contact number, I invite ${companyName} or its
      <a id="trustedPartnersOpen" data-id="trustedPartnersOpen">Trusted Partners</a> to call me during the call centre
      <a id="callCentreHoursOpen" data-id="callCentreHoursOpen">opening hours</a>
       to discuss the potential purchase of a car or home and contents insurance policy.`;
};

export const enableResultsFeatureAccordion = () => false;
export const showPriceConfidenceBanner = () => false;
export const spinnerColour = () => '#1c3e94';
export const spinnerType = () => 'Default';
